import type { IconProps } from '../types/IconProps.ts';
export const SwapVertical: IconProps = {
    name: 'SwapVertical',
    children: [
        `<path d="M7 4v14M3 16l3.65 3.65c.2.2.5.2.7 0L11 16M13 8l3.65-3.65c.2-.2.5-.2.7 0L21 8M17 6v14" />`,
    ]
};